import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyD5zCLevpWfib_5XRY84B2wdX0YRhJs83w",
    authDomain: "phoe-chit-thabin.firebaseapp.com",
    databaseURL: "https://phoe-chit-thabin.firebaseio.com",
    projectId: "phoe-chit-thabin",
    storageBucket: "phoe-chit-thabin.appspot.com",
    messagingSenderId: "290623346558",
    appId: "1:290623346558:web:9e1755e5fda7b98907c52f",
    measurementId: "G-YD4RLSET1X"
};

const firebase = Firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();



export { firebase, storage };